import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { useNavigate } from 'react-router-dom';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import isValidMexicanPhone from '../../utils/isValidMexicanPhone';
import API from '../../api/API';
import { isValidCurp } from 'utils/isValidCurp';
import isValidPassword from 'utils/isValidPassword';
import { CardContent, CardHeader, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
}));

const PasswordContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 100dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
  },
}));

export default function Password() {
  const [snackbarState, setSnackbarState] = React.useState({open: false, message: "", status: "info"});
  const navigate = useNavigate();

  const [curpError, setCurpError] = React.useState(false);
  const [curpErrorMessage, setCurpErrorMessage] = React.useState('');
  
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [nameError, setNameError] = React.useState(false);
  const [nameErrorMessage, setNameErrorMessage] = React.useState('');

  const [lastNameError, setLastNameError] = React.useState(false);
  const [lastNameErrorMessage, setLastNameErrorMessage] = React.useState('');

  const [telephoneError, setTelephoneError] = React.useState(false);
  const [telephoneErrorMessage, setTelephoneErrorMessage] = React.useState('');

  const [showPassword, setShowPassword] = React.useState(false);
  const handleToggleVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  

  const validateInputs = () => {
    const email = document.getElementById('email');
    const curp = document.getElementById('curp');

    let isValid = true;

    if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
      setEmailError(true);
      setEmailErrorMessage('Por favor proporciona un correo valido.');
      isValid = false;
    } else {
      setEmailError(false);
      setEmailErrorMessage('');
    }

    if (!isValidCurp(curp.value)) {
      setCurpError(true);
      setCurpErrorMessage('CURP es invalido.');
      isValid = false;
    } else {
      setCurpError(false);
      setCurpErrorMessage('');
    }


    return isValid;
  };

  const handleSubmit = async(event) => {
    event.preventDefault();
    if (nameError || emailError || passwordError || lastNameError||curpError) {
      return;
    }

    const data = new FormData(event.currentTarget);
    
    const requestBody = {
      email: data.get('email'),
      curp: data.get('curp'),
    };

    const response = await API.patchPassword(requestBody)

    if(response.status == 200){
        setSnackbarState({open:true, message: response.message, status: "success"})
        navigate('/home');
    }else{
        setSnackbarState({open:true, message: response.message, status: "error"})
    }
  }

  return (
      <PasswordContainer direction="column" justifyContent="space-between"  sx={{
        backgroundImage: "url('https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/web%2F14933.jpg?alt=media&token=8cbcf2d8-e15d-47c9-b863-96eeeb8b1dd4')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        
        }}>
        <Card variant="outlined">
        <CardHeader subheader="Please enter your CURP and email, We will sent you a mail for reset your password"></CardHeader>
          {/*<SitemarkIcon />*/}
          <CardContent>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
          >
            <TextField
                required
                fullWidth
                id="curp"
                label="CURP"
                name="curp"
                autoComplete="curp"
                variant="outlined"
                error={curpError}
                helperText={curpErrorMessage}
                color={curpError ? 'error' : 'primary'}
            />
            <TextField
                required
                fullWidth
                id="email"
                label="your@email.com"
                name="email"
                autoComplete="email"
                variant="outlined"
                error={emailError}
                helperText={emailErrorMessage}
                color={emailError ? 'error' : 'primary'}
              />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={validateInputs}
            >
              Enviar
            </Button>
          </Box>
          </CardContent>
          <Divider>
            <Typography sx={{ color: 'text.secondary' }}>or</Typography>
          </Divider>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography sx={{ textAlign: 'center' }}>
              Already have an account?{' '}
              <Link
                href="/login"
                variant="body2"
                sx={{ alignSelf: 'center' }}
              >
                Sign in
              </Link>
            </Typography>
          </Box>
        </Card>
      </PasswordContainer>)
}